import { Tag, Tooltip } from 'antd'
import { menuBuilderGpReviewCopy as copy } from 'src/constants/menuBuilderCopy'
import { getRecipeEconomicsStaleState } from 'src/utils/recipeEconomicsStale'

const STALE_ECONOMICS_TAG_STYLE = {
  backgroundColor: '#e6f7ff',
  borderColor: '#91d5ff',
  color: '#1890ff',
  fontSize: '10px',
  lineHeight: '18px',
  margin: 0,
  fontWeight: 600,
}

const RecipeEconomicsStaleListBadge = ({ recipe, economicsContext = {} }) => {
  const { isStale, lineSum, persistedCostPerRecipe } =
    getRecipeEconomicsStaleState(recipe, economicsContext)

  if (!isStale) {
    return null
  }

  const tooltip = copy.staleEconomicsDescription
    .replace('{lineSum}', lineSum.toFixed(2))
    .replace('{headerCost}', persistedCostPerRecipe.toFixed(2))

  return (
    <Tooltip title={tooltip}>
      <Tag style={STALE_ECONOMICS_TAG_STYLE}>
        {copy.staleEconomicsListBadgeLabel}
      </Tag>
    </Tooltip>
  )
}

export default RecipeEconomicsStaleListBadge
